/**
 * UranIA PA — TanStack Router config (US-009 → US-010).
 *
 * Tree composto programmaticamente da `__root` + figli. Quando saliremo
 * sopra le 10-12 route (US-015/016 onboarding, US-028/029 admin, US-030
 * chat-prova) passeremo al code-gen file-based via
 * `@tanstack/router-plugin/vite`; le firme `createRoute` qui sono già
 * compatibili.
 */

import { createRouter } from '@tanstack/react-router';

import { Route as AdminConsoleRoute } from './routes/admin/index.tsx';
import { Route as AdminComplianceRoute } from './routes/admin/compliance/index.tsx';
import { Route as AdminBancaDatiRoute } from './routes/admin/banca-dati/index.tsx';
import { Route as AdminCorpusRoute } from './routes/admin/corpus/index.tsx';
import { Route as AdminLlmProvidersRoute } from './routes/admin/llm-providers/index.tsx';
import { Route as AdminTipiDocumentoRoute } from './routes/admin/tipi-documento/index.tsx';
import { Route as AdminCutoverGatesRoute } from './routes/admin/cutover-gates/index.tsx';
import { Route as AdminSkillDetailRoute } from './routes/admin/skills/$skillId.tsx';
import { Route as AdminSkillListRoute } from './routes/admin/skills/index.tsx';
import { Route as AdminSkillNewRoute } from './routes/admin/skills/new.tsx';
import { Route as AdminTenantDetailRoute } from './routes/admin/tenants/$tenantId.tsx';
import { Route as AdminTenantListRoute } from './routes/admin/tenants/index.tsx';
import { Route as AuthCallbackRoute } from './routes/auth.callback.tsx';
import { Route as AuthSilentRenewRoute } from './routes/auth.silent-renew.tsx';
import { Route as ChatProvaRoute } from './routes/chat-prova.tsx';
import { Route as CoworkRoute } from './routes/cowork/index.tsx';
import { Route as DashboardRoute } from './routes/dashboard.tsx';
import { Route as IndexRoute } from './routes/index.tsx';
import { Route as LoginRoute } from './routes/login.tsx';
import { Route as OnboardingPaRoute } from './routes/onboarding/pa.tsx';
import { Route as OnboardingRiRoute } from './routes/onboarding/ri.tsx';
import { Route as RootRoute } from './routes/__root.tsx';
import { Route as WorkspaceMod5IndexRoute } from './routes/workspace/mod5.index.tsx';
import { Route as WorkspaceMod5Route } from './routes/workspace/mod5.$docId.tsx';

const routeTree = RootRoute.addChildren([
  IndexRoute,
  LoginRoute,
  AuthCallbackRoute,
  AuthSilentRenewRoute,
  DashboardRoute,
  OnboardingPaRoute,
  OnboardingRiRoute,
  AdminConsoleRoute,
  AdminTenantListRoute,
  AdminTenantDetailRoute,
  AdminSkillListRoute,
  AdminSkillNewRoute,
  AdminSkillDetailRoute,
  AdminCorpusRoute,
  AdminBancaDatiRoute,
  AdminTipiDocumentoRoute,
  AdminLlmProvidersRoute,
  AdminComplianceRoute,
  AdminCutoverGatesRoute,
  ChatProvaRoute,
  CoworkRoute,
  WorkspaceMod5IndexRoute,
  WorkspaceMod5Route,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
